import React, { useState, useEffect } from "react";
import styled from "styled-components";
import CircularProgress from "@material-ui/core/CircularProgress";

import CommonModal from "common/Modal";
import { Business, Star } from "@material-ui/icons";
import { deleteCompanyFavourites, getCompanyFavourites } from "utils/api";
import { useAsyncLoader } from "utils/useAsyncLoader";

const ListOfFavs = styled.div`
  display: flex;
  flex-flow: column nowrap;
  overflow-y: auto;
  justify-content: flex-start;
  align-items: flex-start;
  height: calc(100% - 85px);
`;
const LeftBlock = styled.div`
  display: flex;
  align-items: center;
`;
const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: calc(100% - 36px);
  align-items: center;
  padding: 10px 18px;
  cursor: pointer;
  &:hover {
    background-color: #f1f1f1;
  }
`;
const LoadingState = styled.div`
  display: flex;
  color: ${({ theme }) => theme.primaryColor};
  padding: 20px 0;
  justify-content: center;
  align-items: center;
`;
const Empty = styled.div`
  padding: 10px 18px;
  width: calc(100% - 36px);
  text-align: center;
`;
const Title = styled.p`
  margin: 0;
  font-size: 16px;
  color: rgba(0, 0, 0, 1);
`;
const Content = styled.div`
  margin-left: 15px;
`;
const Description = styled.p`
  margin: 0;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
`;

function FavouriteCompanies({ setToggleModal, toggleModal, setSelectedCompany }) {
  const [favCompanies, setFavCompanies] = useState(0);

  const { isLoading, data } = useAsyncLoader(getCompanyFavourites);

  useEffect(() => {
    if (!data) {
      setFavCompanies([]);
      return;
    }
    setFavCompanies(
      data.sort((a, b) => a.name.toUpperCase().localeCompare(b.name.toUpperCase(), "de"))
    );
  }, [data]);

  return (
    <CommonModal
      isOpen={toggleModal === 3}
      onRequestClose={() => setToggleModal(0)}
      Icon={Star}
      modalTitle="Firmenfavoriten"
    >
      {isLoading ? (
        <LoadingState>
          <CircularProgress disableShrink color="inherit" />
        </LoadingState>
      ) : (
        <ListOfFavs>
          {favCompanies && favCompanies.length > 0 ? (
            favCompanies.map((c, index) => (
              <Row
                key={index}
                onClick={() => {
                  const selCompany = {
                    lat: +c.coordinates.latitude,
                    lon: +c.coordinates.longitude,
                    phone: c.phone,
                    co_name: c.name,
                    id: c.company_id,
                    bisnode_id: c.company_ids?.bisnode_id,
                    description: c.description,
                    isDak: true,
                    favorite: true,
                  };
                  setSelectedCompany(selCompany);
                  setToggleModal(0);
                }}
              >
                <LeftBlock>
                  <Business />
                  <Content title={c.name} alt={c.name}>
                    <Title>{c.name}</Title>
                    <Description>{c.description}</Description>
                  </Content>
                </LeftBlock>
                <div title="Von den Favoriten entfernen" alt="Von den Favoriten entfernen">
                  <Star
                    onClick={e => {
                      e.stopPropagation();
                      deleteCompanyFavourites(c.company_id);
                      setFavCompanies(prevState =>
                        prevState.filter(s => s.company_id !== c.company_id)
                      );
                    }}
                  />
                </div>
              </Row>
            ))
          ) : (
            <Empty>Sie haben keine Favoriten</Empty>
          )}
        </ListOfFavs>
      )}
    </CommonModal>
  );
}

export default FavouriteCompanies;
